export default "__VITE_ASSET__BSMufcWo__"